const M = [
  {
    name: "phoneFeeDataTraffic",
    zh: "话费流量",
    en: "Phone&Data"
  },
  {
    name: "phoneFee",
    zh: "话费",
    en: "Phone"
  },
  {
    name: "dataTraffic",
    zh: "流量",
    en: "Data"
  },
  {
    name: "defaultNumber",
    zh: "默认号码",
    en: "Default number"
  },
  {
    name: "phoneNumberError",
    zh: "手机号错误",
    en: "Mobile number error"
  },
  {
    name: "balanceQuery",
    zh: "余额查询",
    en: "Balance query"
  },
  {
    name: "callChargesInquiry",
    zh: "请选择本机号码运营商查询话费",
    en: "Select the operator of this phone number to inquire the phone charge"
  },
  {
    name: "phoneChargeOptionalAmount",
    zh: "话费充值（选择金额）",
    en: "Recharge (Amount option)"
  },
  {
    name: "dataChargeSelectPackage",
    zh: "流量充值（选择套餐）",
    en: "Data recharge (select package)"
  },
  {
    name: "dataPackage",
    zh: "流量套餐",
    en: "Data package"
  },
  {
    name: "packageDays",
    zh: "套餐天数",
    en: "Package days"
  },
  {
    name: "operatorNotSupport",
    zh: "该运营商暂不支持充值",
    en: "Operator does not support recharge"
  },
  {
    name: "selectPackage",
    zh: "选择套餐",
    en: "Select package"
  },
  {
    name: "pleaseSelectPackage",
    zh: "请选择套餐",
    en: "Select package"
  },
  {
    name: "pleaseSelectOperator",
    zh: "选择您的号码归属的运营商选择错误将会导致充值失败",
    en:
      "Please select the carrier to which your number belongs. incorrect selection will lead to load failure"
  },
  {
    name: "insufficientBalanceChooseOtherPay",
    zh: "余额不足请选择其他支付方式",
    en: "Balance is not enough please choose another payment"
  },
  {
    name: "eTips",
    zh: "小e提醒您批量充值状态有延迟请稍后再查看",
    en:
      "Little E reminds you that there is a delay in the batch recharge status, please check later"
  },
  {
    name: "selectRechargeContent",
    zh: "请选择充值内容",
    en: "Select recharge content"
  },
  {
    name: "batchPhoneFee",
    zh: "批量话费",
    en: "Bulk mobile loading"
  },
  {
    name: "batchDataTraffic",
    zh: "批量流量",
    en: "Bulk data topup"
  },
  {
    name: "timingBatch",
    zh: "定时批量",
    en: "Timing Batch"
  },
  {
    name: "timingBatchPhoneFee",
    zh: "定时批量话费",
    en: "Schedule Bulk mobile loading"
  },
  {
    name: "timingBatchDataTraffic",
    zh: "定时批量流量",
    en: "Schedule Bulk data topup"
  },
  {
    name: "timingRecharge",
    zh: "定时充值",
    en: "Timing Recharge"
  },
  {
    name: "timingRechargeTask",
    zh: "定时充值任务",
    en: "Scheduled load tasks"
  },
  {
    name: "totalNumber",
    zh: "总号码",
    en: "Total"
  },
  {
    name: "wrongNumber",
    zh: "错误号码",
    en: "Error"
  },
  {
    name: "duplicateNumber",
    zh: "重复号码",
    en: "Repeat"
  },
  {
    name: "article",
    zh: "条",
    en: ""
  },
  {
    name: "enterNumberTips",
    zh:
      "请输入0开头的11位菲律宾手机号码，请用[;]或者[换行]隔开，然后去错去重再次确认号码",
    en:
      "Enter the 11-digit Philippines mobile phone number starting with 0, Use [;] or [line feed] to separate, Then remove wrong and duplicate to confirm the number again"
  },
  {
    name: "wrongNumberTips",
    zh: "输入框含有错误号码,是否删除错误号码？",
    en: "Do you want to delete the wrong number?"
  },
  {
    name: "duplicateNumberTips",
    zh: "输入框含有重复号码,是否继续充值？",
    en: "Repetitive number,Do you want to continue to recharge?"
  },
  {
    name: "addLabel",
    zh: "添加标签",
    en: "Add label"
  },
  {
    name: "importNumber",
    zh: "导入号码",
    en: "Import number"
  },
  {
    name: "addFavoriteNumber",
    zh: "添加常用号码",
    en: "Add favorite number"
  },
  {
    name: "viewFavoriteNumber",
    zh: "查看常用号码",
    en: "View favorite number"
  },
  {
    name: "wrongRemoval",
    zh: "去错",
    en: "Wrong removal"
  },
  {
    name: "repetitiveRemoval",
    zh: "去重",
    en: "Duplicate removal"
  },
  {
    name: "open",
    zh: "开启",
    en: "Open"
  },
  {
    name: "close",
    zh: "关闭",
    en: "Close"
  },
  {
    name: "openTips",
    zh:
      "开启后，将在每月设置的日期内，自动充值所选标签的号码，余额不足将无法充值，我们会以短信的方式提醒您尽快充值（仅支持余额付款）",
    en:
      "After opening, the number of the selected label will be automatically load on the date set every month. If the balance is insufficient, you will not be able to load. We will remind you to cash in the wallet as soon as possible by SMS (only balance payment is supported)"
  },
  {
    name: "dateSelection",
    zh: "日期选择",
    en: "Date selection"
  },
  {
    name: "everyMonth",
    zh: "每月",
    en: " every month"
  },
  {
    name: "lastDayOfEveryMonth",
    zh: "每月最后一天",
    en: "Last day of every month"
  },
  {
    name: "addNewLabel",
    zh: "新增标签",
    en: "Add new label"
  },
  {
    name: "enterLabelName",
    zh: "请输入标签名",
    en: "Enter the label name"
  },
  {
    name: "myLabel",
    zh: "我的标签",
    en: "My label"
  },
  {
    name: "labelManagement",
    zh: "标签管理",
    en: "Label management"
  },
  {
    name: "saveNumberToLabel",
    zh: "保存号码至标签",
    en: "Save the number to the label"
  },
  {
    name: "clickNumberToLabel",
    zh: "点击保存输入框中的号码至标签中",
    en: "Click the number to save in the label"
  },
  {
    name: "editLabel",
    zh: "编辑标签",
    en: "Edit label"
  },
  {
    name: "sureLabelAndPhone",
    zh: "确定删除标签及手机号？",
    en: "Are you sure to delete the label and mobile number?"
  },
  {
    name: "selectLabel",
    zh: "请选择标签",
    en: "Select label"
  },
  {
    name: "enter2-4letterOrChinese",
    zh: "请输入2-4个字母数字或者汉字",
    en: "Enter 2-4 letter or Chinese characters"
  },
  {
    name: "newlyAdded",
    zh: "新增",
    en: "Add New"
  },
  {
    name: "newNumber",
    zh: "新增号码",
    en: "New Number"
  },
  {
    name: "editNumber",
    zh: "编辑号码",
    en: "Edit Number"
  },
  {
    name: "clickAddNote",
    zh: "点此添加备注",
    en: "Click here to add note"
  },
  {
    name: "deleteNumber",
    zh: "删除此号码",
    en: "Delete Number"
  },
  {
    name: "mobileEditFailed",
    zh: "手机号编辑失败",
    en: "Mobile number edit failed"
  },
  {
    name: "sureDeleteNumber",
    zh: "确定删除此号码？",
    en: "Are you sure delete this number?"
  },
  {
    name: "sureDeleteTask",
    zh: "确定删除该任务？",
    en: "Are you sure delete the task?"
  },
  {
    name: "addLabelAfterNumber",
    zh: "请添加标签后添加号码",
    en: "Add labels and add numbers"
  },
  {
    name: "labelAlreadyNumber",
    zh: "该标签已存在此号码",
    en: "The label already has this mobile number"
  },
  {
    name: "importLabel",
    zh: "导入标签",
    en: "Import label"
  },
  {
    name: "confirmImport",
    zh: "确认导入",
    en: "Confirm Import"
  },
  {
    name: "labelNoNumber",
    zh: "该标签暂无号码",
    en: "The label has no mobile number"
  },
  {
    name: "import",
    zh: "导入",
    en: "Import "
  },
  {
    name: "export",
    zh: "导出",
    en: "Export "
  },
  {
    name: "immediatelyImport",
    zh: "立即导入",
    en: "Immediately Import"
  },
  {
    name: "rechargeNumber",
    zh: "充值号码",
    en: "Load number"
  },
  {
    name: "operator",
    zh: "运营商",
    en: "Operator"
  },
  {
    name: "fillAmount",
    zh: "填写金额",
    en: "Fill Amount"
  },
  {
    name: "fillMobileNumberAmount",
    zh: "填写号码、金额",
    en: "Fill Mobile number&Amount"
  },
  {
    name: "confirmPay",
    zh: "确认并支付",
    en: "Confirm&Pay"
  },
  {
    name: "rechargeCenter",
    zh: "充值中心",
    en: "Recharge"
  },
  {
    name: "phoneFeeRecharge",
    zh: "话费充值",
    en: "Mobile loading"
  },
  {
    name: "dataTrafficRecharge",
    zh: "流量充值",
    en: "Data topup"
  },
  {
    name: "batchPhoneFeeRecharge",
    zh: "批量话费充值",
    en: "Bulk mobile loading"
  },
  {
    name: "batchDataTrafficRecharge",
    zh: "批量流量充值",
    en: "Bulk data topup"
  },
  {
    name: "noMobileNumber",
    zh: "暂无号码",
    en: "No mobile number"
  },
  {
    name: "rechargeDate",
    zh: "充值日期",
    en: "Recharge date"
  },
  {
    name: "importExcelBatchRechargeTips",
    zh: "您可以将您在excel创建好的号码导入进行批量充值",
    en: "You can import the number you created in excel for batch recharge"
  },
  {
    name: "importUpperLimitTips",
    zh: "单次最多导入1000条，您已超过上限",
    en: "Import up to 1000 numbers at a time, you have exceeded the limit"
  },
  {
    name: "importExcelDataFormatTips",
    zh: "导入的数据格式有问题，请检查excel中的数据",
    en:
      "There is a problem with the imported data format, please check the data in excel"
  },
  {
    name: "wrongDuplicateContinueAdd",
    zh:
      "输入框含有错误号码或重复号码,是否继续添加？继续添加将删除错误号码或重复号码",
    en:
      "The input box contains incorrect or duplicate numbers. Do you want to continue adding? Continue to add will delete wrong or duplicate numbers"
  },
  {
    name: "rechargeLimitTips",
    zh: "注：单笔充值限制1000条",
    en: "Note: Each recharge can have up to 1000 numbers"
  },
  {
    name: "addLabelLimitTips",
    zh: "最多只能添加五个标签",
    en: "You can only add up to five label"
  },
  {
    name: "labelAlreadyExists",
    zh: "该标签已存在",
    en: "The label already exists"
  },
  {
    name: "modifyAndSubmit",
    zh: "请修改之后提交",
    en: "Please modify and submit"
  },
  {
    name: "successfulTransaction",
    zh: "交易成功",
    en: "Successful transaction"
  },
  {
    name: "transactionFailed",
    zh: "交易失败",
    en: "Transaction failed"
  }
];

export default M;
